import { baseLoadFileRequest } from './baseLoadFileRequest';
import { ILoadFileRequestParams } from './types';

export async function loadFileRequest(url: string, params?: ILoadFileRequestParams): Promise<Blob> {
  const response = await baseLoadFileRequest(url, params);
  if (!response.body) throw new Error('No response body');

  const total = Number(response.headers.get('content-length')) || 0;
  let loaded = 0;
  const chunks: Uint8Array[] = [];

  const reader = response.body.getReader();
  let isDone = false;

  try {
    while (!isDone) {
      const { done, value } = await reader.read();
      isDone = done;

      if (!value || isDone) {
        continue;
      }

      chunks.push(value);
      loaded += value.byteLength;

      params?.onProgress?.(
        new ProgressEvent('progress', {
          lengthComputable: total > 0,
          loaded,
          total,
        })
      );
    }
  } finally {
    reader.releaseLock();
  }

  return new Blob(chunks, {
    type: response.headers.get('content-type') || undefined,
  });
}
